import {useQuery} from '@tanstack/react-query'
import {getComplainsWriter} from '../../api/complains'
import {queryKeys} from '../../constants/queryKey'

function useGetComplainsWriterQuery(complainId: string | null) {
  return useQuery<IGetComplains>([queryKeys.complainsWriter], () => getComplainsWriter(complainId), {})
}

export default useGetComplainsWriterQuery
